module.exports = __webpack_public_path__ + "img/qrcode1.010f202e.png";